import { render, staticRenderFns } from "./EditTemplateMapping.vue?vue&type=template&id=048d8cbe&"
import script from "./EditTemplateMapping.vue?vue&type=script&lang=js&"
export * from "./EditTemplateMapping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports